module.exports = __webpack_public_path__ + "static/img/suchunyuan.c053de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/suchunyuan.png
// module id = aWA6
// module chunks = 0